export default __webpack_public_path__ + "static/media/scroll-down-icon.f6581329.svg";